import React from 'react';
import { componentService } from 'js/services/component.service';

export const DynamicChangePin = React.lazy(() => import(/* webpackChunkName: "dynamic-change-pin" */ './DynamicChangePin'));

componentService.registerPageComponents({ 'dynamic-change-pin': DynamicChangePin });
